module.exports = __webpack_public_path__ + "static/slider-7a2e221e2c5b0e118a11120928a62de3.jpg";